import React from 'react';
import SubServices from '../common/sub-services';
const SMMServies = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Get an Extra Edge over Your Competitors by Partnering With Moweb
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 lg:w-8/12 mx-auto">
                    <SubServices
                        path={'/img/icons/ic-increase-roi.svg'}
                        height={64}
                        width={64}
                        alt="consult"
                        title="consult"
                        serviceName="Pace to Market"
                        serviceDescription="Unlike organic SEO, social media marketing can be launched quickly. Our social media experts work hard to drive quality leads and targeted traffic to your business at quite an affordable cost."
                    />
                    <SubServices
                        path={'/img/icons/ic-visibly.svg'}
                        height={64}
                        width={64}
                        alt="development"
                        title="development"
                        serviceName="Increased Visibility"
                        serviceDescription="Being trusted and one of the best social media marketing companies, we are not just responsible for helping you gain better online visibility rather, we help you to expand your business with more user-base."
                    />
                    <SubServices
                        path={'/img/icons/ic-roi.svg'}
                        height={64}
                        width={64}
                        alt="spas"
                        title="spas"
                        serviceName="Maximized ROI"
                        serviceDescription="We just don’t work for the sake, we believe in results. Our social media marketing consultants conduct in-depth conversion analysis and ad testing to drive more clicks per advertisement. It will not only help you to score better ROI but will also drive quality traffic to your website."
                    />
                    <SubServices
                        path={'/img/icons/ic-targeted-ad.svg'}
                        height={64}
                        width={64}
                        alt="portaldevelopment"
                        title="portaldevelopment"
                        serviceName="Geographically Targeted Ads"
                        serviceDescription="We manage social media ads geographically that help you target versatile countries, states, and cities and will appear only to potential customers."
                    />
                </div>
            </div>
        </div>
    );
};

export default SMMServies;
